/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UmbrellaCompanyInvitationRequest
 */
export interface UmbrellaCompanyInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof UmbrellaCompanyInvitationRequest
     */
    email: string;
}

/**
 * Check if a given object implements the UmbrellaCompanyInvitationRequest interface.
 */
export function instanceOfUmbrellaCompanyInvitationRequest(value: object): value is UmbrellaCompanyInvitationRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UmbrellaCompanyInvitationRequestFromJSON(json: any): UmbrellaCompanyInvitationRequest {
    return UmbrellaCompanyInvitationRequestFromJSONTyped(json, false);
}

export function UmbrellaCompanyInvitationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmbrellaCompanyInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function UmbrellaCompanyInvitationRequestToJSON(value?: UmbrellaCompanyInvitationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

